module.exports = __webpack_public_path__ + "img/promotion-banner-sms.18a39a1a.jpg";